import {UseHubSpotFormProps, useHubspotContext} from 'next-hubspot'
import {useState, useRef, useEffect} from 'react'
import {useLogger} from 'src/common/hooks/useLogger'

const useCreateHubspotForm = (formProps: UseHubSpotFormProps) => {
  const {loaded, error} = useHubspotContext()
  const [formCreated, setFormCreated] = useState(false)
  const formIdRef = useRef(formProps.locale)
  const logger = useLogger()

  // Create the form when the script is loaded
  useEffect(() => {
    if (loaded && (!formCreated || formIdRef.current !== formProps.formId)) {
      try {
        window.hbspt.forms.create(formProps)
        setFormCreated(true)
      } catch (e) {
        setFormCreated(false)
        logger.error('Error creating HubSpot form', e)
      }
    }
    // Don't include 'formProps' here to avoid rerenders
  }, [loaded, formCreated, setFormCreated, formProps, logger])

  return {loaded, formCreated, error}
}

export default useCreateHubspotForm
